import {Status, UrlSelection} from 'commonTypes'
import {PaginationState} from '@tanstack/react-table'
import {ConfigurationOption, ConfigurationOptionType, DatabaseMetadata, JobTypeOption} from 'graphql-api'

const defaultDatabasesState = {
  gridSession: {
    pageSizeOptions: [25, 50, 100],
    pagination: {
      pageIndex: 0,
      pageSize: 50,
    } as PaginationState,
    filters: {
      searchQuery: '',
    },
  },
  showDetails: false,
  databaseIdToCopy: '',
  databaseIdCopyTimer: {} as ReturnType<typeof setTimeout>,
  databaseIdCopiedTimer: {} as ReturnType<typeof setTimeout>,
  databases: [] as DatabaseMetadata[],
  database: {} as DatabaseNodeType,
  jobTypeOptions:{
    status: Status.IDLE,
    error: null as any,
    requestId: null as any,
    options: [] as JobTypeOption[],
  },
  currentLegionFeatureFlags:{
    status: Status.IDLE,
    error: null as any,
    requestId: null as any,
    flags: {},
  },
  currentLegionCustomConfigOverrides:{
    status: Status.IDLE,
    error: null as any,
    requestId: null as any,
    overridesByJobType: [] as any[],
  },
  status: Status.IDLE,
  statusDetails: Status.IDLE,
  error: null as any,

  showBulkEditPanel: false,
  specifiedUrls: '' as string,
  urlOption: {
    value: UrlSelection.EMPTY,
    label: '',
  },
  configurationOption: {
    value: '',
    label: '',
    type: ConfigurationOptionType.Boolean,
  },
  configurationValue: '' as string,
  configurationEnabled: false,
  configurationOptions:{
    status: Status.IDLE,
    error: null as any,
    requestId: null as any,
    options: [] as ConfigurationOption[],
  },
}

export type GridSessionType = typeof defaultDatabasesState.gridSession

export type FiltersType = typeof defaultDatabasesState.gridSession.filters

export type DatabasesStateType = typeof defaultDatabasesState

export type DatabaseNodeType = DatabaseMetadata | null | undefined

export default defaultDatabasesState
